import { getOfferProduct, sendAnalytics } from 'shared/utils/analytics';

interface ITrackComparisonChangeParams {
  offerId: number;
  position: number;
  label?: string;
  houseId: number;
  isAdded: boolean;
}

export const trackComparisonChange = ({ isAdded, label, offerId, position, houseId }: ITrackComparisonChangeParams) =>
  sendAnalytics({
    category: 'Compare',
    action: isAdded ? 'Add' : 'Remove',
    label,
    products: [getOfferProduct(offerId, position)],
    page: {
      extra: { houseId },
    },
  });
